// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__OLqAn","inputWrap":"CustomTip_inputWrap__1rGU_"};